
  import BonAPIResults from "@/components/BonAPIResults.vue"; // @ is an alias to /src

  export default {
    name: 'Results',
    components: {
      BonAPIResults
    }
  }
